import { socketSendAction } from "../state-areas/socket/actions";

import { ACTION_TYPES } from "./constants";

export const deleteComment = ({ messageId, context, roomId, taskId }) => (dispatch, getState) => {
  const loggedUser = getState()?.userReducer?.user;

  dispatch(socketSendAction('delete-message', { messageId, userId: loggedUser?._id, context, roomId }));

  dispatch({
    type: ACTION_TYPES.DELETE_COMMENT_SUCCESS,
    payload: {
      messageId,
      taskId
    }
  })
};
